/**
 * Browser-side file download — turns bytes into a Blob, creates an
 * object URL, clicks a hidden `<a>` with the given filename, and
 * revokes the URL shortly after. Works in every modern browser
 * without any server round-trip.
 */

export function downloadBytes(bytes: Uint8Array, filename: string, mime = 'application/json') {
  // Copy into a fresh backing buffer so the Blob never aliases any
  // ArrayBuffer-or-SharedArrayBuffer ambiguity in the source.
  const buf = new Uint8Array(bytes.byteLength);
  buf.set(bytes);
  const blob = new Blob([buf], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.setTimeout(() => URL.revokeObjectURL(url), 2000);
}
